import { memo, useMemo } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import Typography from 'components/UI/Typography/Typography';

import {
  MEDIA_BANNERS_CONFIG,
  MEDIA_BANNER_TYPES,
  MEDIA_COMPLETED_TASKS_REQUIRED,
} from 'components/config/rewardSystem';

import styles from './MediaBanners.module.scss';

const MediaBanners = ({ tasksCompleted, raffleResults }) => {
  const type = useMemo(() => {
    if (raffleResults?.ended) {
      return raffleResults.won
        ? MEDIA_BANNER_TYPES.win
        : MEDIA_BANNER_TYPES.loss;
    }

    return tasksCompleted >= MEDIA_COMPLETED_TASKS_REQUIRED
      ? MEDIA_BANNER_TYPES.reached
      : MEDIA_BANNER_TYPES.unReached;
  }, [tasksCompleted, raffleResults]);

  const { title, description } = MEDIA_BANNERS_CONFIG[type];

  return (
    <div className={classNames(styles.root, styles[`root-${type}`])}>
      {title}
      {description && (
        <Typography color="white" className={styles.description}>
          {description}
        </Typography>
      )}
    </div>
  );
};

MediaBanners.propTypes = {
  tasksCompleted: PropTypes.number,
  raffleResults: PropTypes.shape({
    ended: PropTypes.bool,
    won: PropTypes.bool,
  }),
};

export default memo(MediaBanners);
